import { FEEDBACK_LINK, HELP_LINK } from '../constants/externalLinks';
import { APP_PATHS } from '../constants/paths';
import { ChatGPT } from '../icons/ChatGPT/ChatGPT';
import { Feedback } from '../icons/Feedback/Feedback';
import { Help } from '../icons/Help/Help';
import { SignOut } from '../icons/SignOut/SignOut';
import { Videos } from '../icons/Videos/Videos';

export const mapNavDrawerListItems = (
  navigateInternal,
  navigateExternal,
  handleSignOut,
) => [
  {
    name: 'coach',
    icon: <ChatGPT />,
    onClick: () => navigateInternal(APP_PATHS.coach),
  },
  {
    name: 'videos',
    icon: <Videos />,
    onClick: () => navigateInternal(APP_PATHS.videos),
  },
  {
    name: 'help',
    icon: <Help />,
    onClick: () => navigateExternal(HELP_LINK),
  },
  {
    name: 'feedback',
    icon: <Feedback />,
    onClick: () => navigateExternal(FEEDBACK_LINK),
  },
  {
    name: 'signOut',
    icon: <SignOut />,
    onClick: handleSignOut,
  },
];
